export function initFormAjax () {
    /*BX.ajax({
        method: 'POST',
        dataType: 'html',
        url: '/ajax/form_auth_register_result.php',
        data: {test: '11'},
        onsuccess: BX.proxy(formAuthRegisterAjax, this)
    });*/

    $.ajax({
        url: '/ajax/form_auth_register_result.php',
        method: 'post',
        dataType: 'html',
        data: {text: 'Текст'},
        success: function(data){
            formAuthRegisterAjax(data);
        }
    });
}



// какие-то события по клику в форме
export function eventFormClick (form) {

    const inputsText = form.querySelectorAll('.input_text');

    inputsText.forEach((input) => {
        input.addEventListener('focus', function (e) {
            if(!e.target || e.target.tagName !== 'INPUT') return;

            if (!e.target.value.length) {
                e.target.closest('.input_wrapper').classList.add('focus')
            }
        });
    })

}

// нажата кнопка отправить
export function submitButtonPressed (e, inputs, licenseKey)
{
    let arError = [];
    let arResult = {};

    inputs.forEach((input) => {
        if (!input.value.length) {
            arError.push(input.getAttribute('name'));
            input.closest('.input_wrapper').classList.remove('_success')
            input.closest('.input_wrapper').classList.add('_error')
        } else {
            input.closest('.input_wrapper').classList.remove('_error');
            input.closest('.input_wrapper').classList.add('_success');

            arResult[input.getAttribute('name')] = input.value;
        }
    });

    arResult.LICENSE_KEY = licenseKey;

    BX.ajax({
        method: 'POST',
        dataType: 'json',
        url: '/ajax/form_auth.php',
        data: arResult,
        onsuccess: BX.proxy(formAuthRegisterAjax, this)
    });

    e.preventDefault();
}

function formAuthRegisterAjax (data) {
    const form = document.querySelector('.dws_modal_auth');
    const authResult = form.querySelector('.auth_status_result');
    authResult.innerText = '';
    authResult.classList.remove('_error', '_success');

    if (data.status === 'error') {
        authResult.classList.add('_error');
    } else if (data.status === 'success') {
        authResult.classList.add('_success');
        setTimeout(function(){
            location.reload();
        }, 1500);
    }

    authResult.insertAdjacentHTML("afterbegin", data.msg);
}